import { usePost } from './useHttpHooks.ts';

interface CreateThreadResponse {
    threadId: string;
}

const usePostCreateThread = () =>
    usePost<NonNullable<object>, CreateThreadResponse>(
        '/api/knowledge-assistant/threads/create',
        {
            errorMessage: 'POST /api/knowledge-assistant/threads/create'
        }
    );

export default usePostCreateThread;
